<template>
    <div
        class="fixed top-0 left-0 w-full h-full transition"
        :class="{ 'opacity-0 pointer-events-none': !isOpen }"
        style="background: rgba(0, 0, 0, 0.7)"
        @click="togglerFn"
        @keyup.esc="togglerFn"
    ></div>
</template>

<script>
export default {
    name: 'BgOverlay',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        togglerFn: {
            type: Function,
            required: false,
            default: () => {},
        },
    },
};
</script>

<style scoped></style>
